import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <Link
      to={`/categories/${item?.slugPath || item?.slug}`}
      className="custom-category-card text-decoration-none"
    >
      <img
        src={item.image}
        alt={item.name}
        className="custom-category-card-img"
      />

      <div className="custom-category-card-overlay" />

      <div className="custom-category-card-content">
        <div>
          <h4 className="custom-category-card-title">{item.name}</h4>
          <p className="custom-category-card-text">
            Explore premium products for every need.
          </p>
        </div>

        <span className="custom-category-card-btn">
          <ArrowRight size={16} />
        </span>
      </div>
    </Link>
  );
}

export default Card;